module.exports = __webpack_public_path__ + "static/img/bjqk.7a92d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bjqk.png
// module id = V8s7
// module chunks = 0